import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // Prevent browser from automatically restoring previous scroll position
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.history && 'scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    } catch (e) {}
  }, []);

  useEffect(() => {
    // Immediately force top, and add a short delayed fallback to override browser behavior
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      const id = setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' }), 50);
      return () => clearTimeout(id);
    } catch (e) {
      try {
        window.scrollTo(0, 0);
      } catch (err) {}
    }
  }, [pathname]);

  return null;
}


